var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: { title: _vm.title, size: "lg", "hide-footer": "", centered: "" },
    },
    [
      _vm.occurrence
        ? _c(
            "div",
            { staticClass: "p-1" },
            [
              _c("div", { staticClass: "border rounded p-1 mb-2" }, [
                _c("div", { staticClass: "flex justify-between mb-50" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("lesson.agenda.occurrence"))),
                  ]),
                  _c("small", { staticClass: "font-medium capitalize" }, [
                    _vm._v(_vm._s(_vm.occurrenceLabel)),
                  ]),
                ]),
                _c("div", { staticClass: "flex justify-between" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("lesson.agenda.occupancy"))),
                  ]),
                  _c("small", [
                    _vm._v(
                      _vm._s(_vm.occurrence.occupied) +
                        "/" +
                        _vm._s(
                          _vm.occurrence.capacity === null
                            ? "∞"
                            : _vm.occurrence.capacity
                        )
                    ),
                  ]),
                ]),
              ]),
              _vm.mode === "capacity"
                ? [
                    _c(
                      "b-form-group",
                      {
                        attrs: { label: _vm.$t("lesson.agenda.new_capacity") },
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            type: "number",
                            min: "1",
                            max: "999",
                            placeholder:
                              "" +
                              (_vm.occurrence.capacity === null
                                ? ""
                                : _vm.occurrence.capacity),
                          },
                          model: {
                            value: _vm.capacity,
                            callback: function ($$v) {
                              _vm.capacity = _vm._n($$v)
                            },
                            expression: "capacity",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("small", { staticClass: "text-muted d-block mb-2" }, [
                      _vm._v(_vm._s(_vm.$t("lesson.agenda.capacity_hint"))),
                    ]),
                    _vm.capacity && _vm.capacity < _vm.occurrence.occupied
                      ? _c(
                          "b-alert",
                          {
                            staticClass: "p-1 mb-2",
                            attrs: { show: "", variant: "warning" },
                          },
                          [
                            _c("small", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "lesson.agenda.capacity_below_occupancy_warning",
                                    { occupied: _vm.occurrence.occupied }
                                  )
                                )
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm.mode === "block"
                ? [
                    _c(
                      "b-alert",
                      {
                        staticClass: "p-1 mb-2",
                        attrs: { show: "", variant: "warning" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-start" },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-1 flex-shrink-0",
                              attrs: { icon: "AlertTriangleIcon" },
                            }),
                            _c("small", [
                              _vm._v(
                                _vm._s(_vm.$t("lesson.agenda.block_hint"))
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm.mode === "cancel"
                ? _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("cancellation.club_cancel_reason"),
                      },
                    },
                    [
                      _c("b-form-select", {
                        staticClass: "required",
                        attrs: { options: _vm.reasonOptions },
                        model: {
                          value: _vm.reason,
                          callback: function ($$v) {
                            _vm.reason = $$v
                          },
                          expression: "reason",
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "b-form-group",
                    { attrs: { label: _vm.$t("lesson.agenda.reason") } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            "lesson.agenda.reason_placeholder"
                          ),
                        },
                        model: {
                          value: _vm.reason,
                          callback: function ($$v) {
                            _vm.reason = $$v
                          },
                          expression: "reason",
                        },
                      }),
                    ],
                    1
                  ),
              _vm.mode === "cancel"
                ? [
                    _vm.impact
                      ? _c("div", { staticClass: "border rounded p-1 mb-2" }, [
                          _c("div", { staticClass: "font-medium mb-1" }, [
                            _vm._v(
                              _vm._s(_vm.$t("cancellation.club_cancel_impact"))
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "flex justify-between mb-50" },
                            [
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("cancellation.club_cancel_students")
                                  )
                                ),
                              ]),
                              _c("small", [
                                _vm._v(_vm._s(_vm.impact.affected_students)),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "flex justify-between mb-50" },
                            [
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("cancellation.club_cancel_refund")
                                  )
                                ),
                              ]),
                              _c("small", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatValue(
                                      _vm.impact.full_refund_total
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "flex justify-between mb-50" },
                            [
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("cancellation.club_cancel_transfer")
                                  )
                                ),
                              ]),
                              _c("small", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatValue(
                                      _vm.impact.settled_transfer_reversal
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _c("div", { staticClass: "flex justify-between" }, [
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                _vm._s(_vm.$t("cancellation.club_cancel_fee"))
                              ),
                            ]),
                            _c("small", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatValue(_vm.impact.hubee_fee_returned)
                                )
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex justify-between items-center border rounded p-1 mb-2",
                      },
                      [
                        _c("div", [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "cancellation.club_cancel_mass_reschedule"
                                )
                              )
                            ),
                          ]),
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("cancellation.club_cancel_mass_hint")
                              )
                            ),
                          ]),
                        ]),
                        _c("b-form-checkbox", {
                          attrs: { switch: "" },
                          model: {
                            value: _vm.offerReschedule,
                            callback: function ($$v) {
                              _vm.offerReschedule = $$v
                            },
                            expression: "offerReschedule",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-alert",
                      {
                        staticClass: "p-1 mb-2",
                        attrs: { show: "", variant: "danger" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-start" },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-1 flex-shrink-0",
                              attrs: { icon: "AlertTriangleIcon" },
                            }),
                            _c("small", [
                              _vm._v(
                                _vm._s(_vm.$t("lesson.agenda.cancel_warning"))
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm.mode === "grant"
                ? [
                    _c(
                      "b-alert",
                      {
                        staticClass: "p-1 mb-2",
                        attrs: { show: "", variant: "warning" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-start" },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-1 flex-shrink-0",
                              attrs: { icon: "AlertTriangleIcon" },
                            }),
                            _c("small", [
                              _vm._v(
                                _vm._s(_vm.$t("schedule_event.seat_grant_hint"))
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("schedule_event.seat_grant_student"),
                        },
                      },
                      [
                        _c("select-suggestion", {
                          ref: "grantStudent",
                          attrs: {
                            column: "name,email",
                            model: "User",
                            label: null,
                            appendClearOption: true,
                            placeholderText: "Digite o nome ou e-mail do aluno",
                            itemTextFormat: _vm.studentItemTextFormat,
                          },
                          model: {
                            value: _vm.grantStudent,
                            callback: function ($$v) {
                              _vm.grantStudent = $$v
                            },
                            expression: "grantStudent",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("schedule_event.seat_grant_scope"),
                        },
                      },
                      [
                        _c("b-form-radio-group", {
                          attrs: {
                            options: _vm.grantScopeOptions,
                            stacked: "",
                            "value-field": "value",
                            "text-field": "label",
                          },
                          model: {
                            value: _vm.grantScope,
                            callback: function ($$v) {
                              _vm.grantScope = $$v
                            },
                            expression: "grantScope",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "div",
                { staticClass: "flex justify-end gap-4" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-2",
                      attrs: { variant: "outline-secondary" },
                      on: { click: _vm.close },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("back")) + " ")]
                  ),
                  _vm.mode === "grant"
                    ? _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "success",
                            disabled: !_vm.grantStudent || !_vm.grantStudent.id,
                          },
                          on: { click: _vm.saveGrant },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("schedule_event.seat_grant")) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.mode === "capacity"
                    ? _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "warning",
                            disabled: !_vm.capacity,
                          },
                          on: { click: _vm.saveCapacity },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("lesson.agenda.adjust_capacity")) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.mode === "block"
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "dark" },
                          on: { click: _vm.saveBlock },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("lesson.agenda.block")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.mode === "cancel"
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "danger", disabled: !_vm.reason },
                          on: { click: _vm.executeCancel },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("cancellation.club_cancel_confirm", {
                                  count: _vm.impact
                                    ? _vm.impact.affected_students
                                    : 0,
                                })
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }